module.exports = __webpack_public_path__ + "static/media/food-icon.785b5fd3.svg";